/* globals axios */

import Vue from 'vue';
import { gsap } from 'gsap';
import Errors from '../classes/Errors';

Vue.component('assessment-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            showIntro: true,
            showQuestions: false,
            currentQuestion: 1,
            showEnd: false,
            nextActive: false,
            answer1: null,
            answer2: null,
            answer3: null,
            showDisclaimerCta: false,
            showDisclaimer: false,
            showNavigation: false,
            showForm: false,
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.animateIntro();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        animateIntro() {
            gsap.to('.assesment-intro__title', {
                autoAlpha: 1, y: 0, duration: 0.8, delay: 0.4,
            });

            gsap.to('.assesment-intro__menu-item', {
                delay: 0.4,
                duration: 2,
                autoAlpha: 1,
                x: 0,
                ease: 'power3.out',
                stagger: 0.1,
            });
        },

        startAssessment() {
            this.showIntro = false;
            this.showQuestions = true;
            this.showDisclaimerCta = true;
            this.showNavigation = true;

            Vue.nextTick(() => {
                const introTl = gsap.timeline({ delay: 0.2 });

                introTl.to('.assesment-questions__indicator', {
                    autoAlpha: 1, y: 0, duration: 0.8,
                }, 0);
                introTl.to('.assesment-question--01 .assesment-question__title', {
                    autoAlpha: 1, y: 0, duration: 0.8,
                }, 0.2);
                introTl.to('.assesment-question--01 .checkbox-holder', {
                    autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.2,
                }, 0.6);
                introTl.to('.assesment-questions__disclaimer-link', {
                    autoAlpha: 1, duration: 1,
                }, 1.6);
                introTl.to('.assesment-questions__navigation-container', {
                    autoAlpha: 1, y: 0, duration: 0.8,
                }, 1.8);
            });
        },

        next() {
            if (this.currentQuestion === 3) {
                this.showQuestions = false;
                this.showForm = true;
                this.nextActive = false;

                const revealTl = gsap.timeline({ delay: 0.2 });

                revealTl.to('.assesment-form .question-title', {
                    autoAlpha: 1, y: 0, duration: 0.8,
                });
                revealTl.to('.assesment-form .assesment-question__form', {
                    autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.2,
                }, 0.4);
            } else {
                this.nextActive = false;
                this.currentQuestion += 1;
            }

            if (this.currentQuestion === 2) {
                const revealTl = gsap.timeline({ delay: 0.2 });

                revealTl.to('.assesment-question--02 .assesment-question__title', {
                    autoAlpha: 1, y: 0, duration: 0.8,
                });
                revealTl.to('.assesment-question--02 .checkbox-holder', {
                    autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.2,
                }, 0.4);
            }

            if (this.currentQuestion === 3) {
                const revealTl = gsap.timeline({ delay: 0.2 });

                revealTl.to('.assesment-question--03 .assesment-question__title', {
                    autoAlpha: 1, y: 0, duration: 0.8,
                });
                revealTl.to('.assesment-question--03 .checkbox-holder', {
                    autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.2,
                }, 0.4);
            }
        },

        previous() {
            if (this.showForm === true) {
                this.showForm = false;
                this.showQuestions = true;
            } else if (this.currentQuestion === 1) {
                this.showQuestions = false;
                this.showIntro = true;
                this.showNavigation = false;
                gsap.delayedCall(0.1, () => {
                    this.animateIntro();
                });
            } else {
                this.currentQuestion -= 1;
                this.nextActive = true;
            }
        },

        openDisclaimer() {
            this.showDisclaimer = true;
        },

        closeDisclaimer() {
            this.showDisclaimer = false;
        },

        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios
                .post('/', new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        this.scrollToFirstError();
                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    this.showQuestions = false;
                    this.showDisclaimerCta = false;
                    this.showNavigation = false;
                    this.showEnd = true;
                })
                .catch((error) => {
                    this.submitting = false;
                    console.log(error.response);
                });
        },
    },
});
